
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import AppErrorMessage from "@/components/common/ErrorMessageBox.vue";
import { AuthService } from "../../services/auth-service";
import { isPasswordStrongEnough } from "../../utils/strings";
import { HttpError } from "../../utils/services/http-error";
import AppEnableTotp from "./EnableTotp.vue";
import AppDisableTotp from "./DisableTotp.vue";

export default FormLike.extend({
	data(){
		return {
			inputs: {
				current: "",
				new: "",
				repeat: ""
			},
			usedInputs: {
				current: false,
				new: false,
				repeat: false
			},
			errorMessages: [] as string[],
			replyError: "",
			enableTotp: false,
			disableTotp: false
		};
	},
	computed: {
		shownErrorMessage():string{
			if (this.errorMessages[0]){
				return this.$ct(`errors.${this.errorMessages[0]}`).toString();
			}
			return this.replyError || "";
		},
		isTotpEnabled():boolean {
			return AuthService.wfUser.TotpEnabled;
		}
	},
	watch: {
		inputs: {
			deep: true,
			handler(){
				this.errorMessages = [];
			}
		},
		usedInputs: {
			deep: true,
			handler(){
				this.validate();
			}
		}
	},
	methods: {
		async submit(){
			if (!this.isValid) return;
			try{
				await AuthService.changePassword(this.inputs.current, this.inputs.new);
				this.reset();
				this.$wf.notify(this.$ct("common.success").toString(), "success", 3000, "check");
			}catch(err){
				let error = err as HttpError;
				error.dontShow = true;
				this.replyError = error.getText();
			}
		},
		reset(){
			this.inputs.current = "";
			this.inputs.new = "";
			this.inputs.repeat = "";
			this.usedInputs.current = false;
			this.usedInputs.new = false;
			this.usedInputs.repeat = false;
		},
		passwordStrongEnough():boolean {
			if (!isPasswordStrongEnough(this.inputs.new)){
				if (this.usedInputs.new){
					this.errorMessages.push("password-not-strong-enough");
				}
				return false;
			}
			return true;
		},
		passwordsMatch():boolean{
			if (this.inputs.new != this.inputs.repeat){
				if (this.usedInputs.repeat){
					this.errorMessages.push("passwords-dont-match");
				}
				return false;
			}
			return true;
		},
		async closeTotp(){
			this.enableTotp = false;
			this.disableTotp = false;
			await AuthService.getUserInfo();
		}
	},
	created(){
		this.validators = [
			this.passwordStrongEnough,
			this.passwordsMatch
		];
		this.validate();
	},
	components: {
		AppErrorMessage,
		AppEnableTotp,
		AppDisableTotp
	},
	i18nEx: {
		componentPrefix: "components.account"
	}
});
